export default {
  title: "Historique des calculs",
  type: "Type",
  routeSearch: "Recherche d'itinéraire",
  batchId: "ID du lot",
  createdAt: "Créé le",
  totalDistance: "Distance totale (km)",
  productionEmission: "Émission de production (kg CO2e)",
  transportEmission: "Émission de transport (kg CO2e)",
  totalEmission: "Émission totale (kg CO2e)",
  taxInEUR: "Taxe (€)",
  action: "Action",
  detail: "Détail",
  deleteConfirm: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
  data: "Données",
  reports: "Rapports",
  batchDownload: "Téléchargement groupé",
  batchDownloadPdf: "Télécharger PDF en lot",
  batchDownloadExcel: "Télécharger Excel en lot",
  selectPlaceholder: "Veuillez sélectionner au moins un enregistrement",
  quotaInsufficient:
    "Quota insuffisant, veuillez passer à une offre supérieure ou effectuer un achat",
  batchDownloadSuccess: "Téléchargement groupé terminé, sélection réinitialisée",
  batchDownloadFailed: "Échec du téléchargement groupé",
  emptyFile: "Le fichier généré est vide",
  downloadProgress: "Progression du téléchargement",
  completed: "terminé",
  but: "mais",
  regenerate: "Régénérer",
};
